import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Contacts() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Contacts'}]}/>
      <Paper>
        <Table canExport={true}/>
      </Paper>
    </div>
  );
}
